export default {
  default: '0.625rem',
  xl: '28px',
  lg: '0.75rem',
  md: '0.625rem',
  sm: '0.3125rem',
};
